import { createFileRoute } from "@tanstack/react-router";

import PasswordRequestPage from "@/components/Password/PasswordRequestPage";

export const Route = createFileRoute("/account/password/request")({
  validateSearch: (search) =>
    search as {
      malformed?: boolean;
    },
  component: PasswordRequestPage,
});
